const sub = (a, b) => a - b;
export default sub;
